module.exports = __webpack_public_path__ + "static/media/catalouge-04.c1d96710.jpg";